var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10.5,
    fill: "#4F68E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 4L11.8906 4.36465V14.9451L11.9999 15.0522L16.9981 12.1492L11.9999 4Z",
    fill: "#C0CBF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9984 4L7 12.1492L11.9984 15.0522V9.91677V4Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9991 15.9802L11.9375 16.054V19.8229L11.9991 19.9995L17.0004 13.0786L11.9991 15.9802Z",
    fill: "#C0CBF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9984 19.9995V15.9802L7 13.0786L11.9984 19.9995Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.998 15.0569L16.9963 12.1538L11.998 9.92139V15.0569Z",
    fill: "#8197EE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.1543L11.9984 15.0573V9.92188L7 12.1543Z",
    fill: "#C0CBF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/ETH.f05df26a50b394320ec2a6495c3702c2.svg";
export { ForwardRef as ReactComponent };